import React,{useEffect,useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import { useAlert } from "react-alert";
import { Link,useNavigate,useParams } from "react-router-dom";
import MetaData from '../../components/MetaData.js';
import { clearErrors, getOrderDetails, updateOrder } from "../../actions/orderAction";
import Loader from "../Loader";
import { Button } from "@material-ui/core";
import { UPDATE_ORDER_RESET } from "../../constants/orderConstant";

const ProcessOrder = () => {

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {id} = useParams();
  	const alert = useAlert();
  	const [status, setStatus] = useState("");
	const { order, error, loading } = useSelector((state) => state.orderDetails);

	const { error: updateError, isUpdated } = useSelector((state) => state.order);

	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

    const fetchExchangeRates = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error("Failed to fetch exchange rates");
        const data = await response.json();

        setCountryToCurrency((prev) => {
          const updatedCurrencies = { ...prev };

          Object.keys(updatedCurrencies).forEach((country) => {
            const currencyCode = updatedCurrencies[country].currencyCode;
            const rate = data.rates[currencyCode];
            if (rate) {
              updatedCurrencies[country].rate = rate;
            }
          });

          return updatedCurrencies;
        });
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    // Fetch user's country using their IP address
    const fetchUserCountry = async () => {
    try {
      const response = await fetch("https://get.geojs.io/v1/ip/country.json");
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      return data.country || "GB";
    } catch (error) {
      console.error("Error fetching user country:", error);
      return "GB"; // Default to GB on failure
    }
  };


    const loadCurrencyDetails = async () => {
    setIsLoading(true);
    await fetchExchangeRates();
    const userCountry = await fetchUserCountry();
    setCountryCode(userCountry);
    // Use updated rates
  setCountryToCurrency((prev) => {
    const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
    setCurrencySymbol(currencyInfo.symbol || "£");
    return prev;
  });
    setIsLoading(false);
  };

  useEffect(() => {
    loadCurrencyDetails();
  }, []);

	const updateOrderSubmitHandler = (e) => {
	    e.preventDefault();

	    const myForm = new FormData();

	    myForm.set("status", status);

	    dispatch(updateOrder(id, myForm));
	};

	useEffect(() => {
	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }
	    if (updateError) {
	      alert.error(updateError);
	      dispatch(clearErrors());
	    }
	    if (isUpdated) {
	      alert.success("Order Updated Successfully");
	      dispatch({ type: UPDATE_ORDER_RESET });
	    }

	    dispatch(getOrderDetails(id));
	}, [dispatch, alert, error, id, isUpdated, updateError]);

	return (
		<>
		{loading ? (
            <Loader />
          ) : (
          <>
			<MetaData title="Process Order" />
      		<div className="section section-padding update_password dashboard-panel">
        	<div className="container">
        	
            <div className="row justify-content-center">
	        <div className="col-12">
      		<div className="confirmOrderPage row">
            <Sidebar />	

      			<div className="col-lg-6 col-md-12 col-sm-12">
		          <div className="orderDetailsContainerBox">
	              <h4>Contact Details</h4>
	                <div>
	                  <p><b>Name:</b></p>
	                  <span>{order?.user && order.user.name}</span>
	                </div>
	                <div>
	                  <p><b>Phone:</b></p>
	                  <span>
	                    {order?.shippingInfo && order.shippingInfo.phoneNo}
	                  </span>
	                </div>
	                <div>
	                  <p><b>Address:</b></p>
	                  <span>
	                    {order?.shippingInfo &&
	                      `${order.shippingInfo.address}, ${order.shippingInfo.city}, ${order.shippingInfo.state}, ${order.shippingInfo.pinCode}, ${order.shippingInfo.country}`}
	                  </span>
	                </div>
	              </div>
		          <div className="orderDetailsContainerBox">
	              <h4>Payment</h4>
	                <div>
	                  <p
	                    className={
	                      order?.paymentInfo &&
	                      order.paymentInfo.status === "succeeded"
	                        ? "text-success"
	                        : "text-danger"
	                    }
	                  >
	                    <b>{order?.paymentInfo &&
	                    order.paymentInfo.status === "succeeded"
	                      ? "PAID"
	                      : "NOT PAID"}
	                      </b>
	                  </p>
	                </div>
	                <div>
	                  <p><b>Amount:</b></p>
	                  <span>£{order?.totalPrice && order.totalPrice}</span>
	                </div>
               		</div>
               		<div className="orderDetailsContainerBox">
		              <h4>Order Status</h4>
		                <div>
		                {/*<p>Completed</p>*/}
		                  <p
		                    className={
		                      order?.orderStatus && order.orderStatus === "Delivered"
		                        ? "text-success"
		                        : "text-danger"
		                    }
		                  >
		                    <b>{order?.orderStatus && order.orderStatus}</b>
		                  </p>
		                </div>
		              </div>
		          <div className="confirmCartItems">
		            <h3>Your Cart Items:</h3>
		            <div className="confirmCartItemsContainer">
		              {/*{order.orderItems &&
                      order.orderItems.map((item) => (
                        <div key={item.product}>
                          <img src={item.image} alt="Product" />
                          <Link to={`/product/${item.product}`}>
                            {item.name}
                          </Link>{" "}
                          <span>
                            {item.quantity} X £{item.price} ={" "}
                            <b>£{item.price * item.quantity}</b>
                          </span>
                        </div>
                      ))}*/}
		            {order?.orderItems &&
		                  order?.orderItems.map((item) => {
		                  	const rate = countryToCurrency[countryCode]?.rate || 1;
						    const symbol = countryToCurrency[countryCode]?.symbol || "£";

						    // Calculate the localized item price (base price)
						    const localizedItemPrice = (item.price * rate).toFixed(2);

						    // Calculate the total item price with VAT applied
						    const totalPriceWithVAT = (
						      item.price * item.quantity * (1 + item.vat / 100) * rate
						    ).toFixed(2);

		                  	return(
		                    <div className="row" key={item.product}>
		                      <div className="col-md-8 col-12">
		                      	{/*<img src={item?.image} alt="Product" />*/}
			                      <Link className="text-capitalize" to={`/product/${item.product}`}>
			                        <b>{item.name} ( {item.topic} )</b>
			                      </Link>
		                      </div>
		                      <div className="col-md-4 col-12 text-end">
		                      	<span>
			                      {item.quantity} X £{item.price} 
			                      {/*<sub>{symbol} {localizedItemPrice}</sub>*/}
			                       + VAT {item.vat}% =
			                      <b className="mx-1">£{parseFloat((item.price * item.quantity * (1 + item.vat / 100)).toFixed(10))}</b>
			                    </span>
		                      </div>
		                      {/*<span>
					          {item.quantity} X {symbol}
					          {localizedItemPrice} + VAT {item.vat}% = 
					          <b className="mx-1">
					            {symbol}
					            {totalPriceWithVAT}
					          </b>
					        </span>*/}
		                    </div>
		                  );
						})}
		            </div>
		          </div>
		        </div>
		        <div className="col-lg-3 col-md-12 col-sm-12">
		        	<div className="updateOrderForm">
		        		<form
		                  onSubmit={updateOrderSubmitHandler}
		                >
		                  <h3>Process Order</h3>

		                  <div className="single-form">
		                    
		                    <select onChange={(e) => setStatus(e.target.value)}>
		                      <option value="">Choose Category</option>
		                      {order.orderStatus === "Processing" && (
		                        <option value="Completed">Completed</option>
		                      )}

		                      {order.orderStatus === "Completed" && (
		                        <option value="Delivered">Delivered</option>
		                      )}
		                    </select>
		                  </div>

		                  <Button
		                    id="createProductBtn"
		                    className="btn btn-primary btn-hover-dark btn-margin mt-4 w-100"
		                    type="submit"
		                    disabled={
		                      loading ? true : false || status === "" ? true : false
		                    }
		                  >
		                    Process
		                  </Button>
		                </form>
		        	</div>
		        </div>
		    </div>
		    </div>
		    </div>
		    </div>
		    </div>
		    </>
		    )}
		</>
	)
}

export default ProcessOrder